import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_ENABLE_FOLKSONOMY_TOPICS = createFcmConfig('enable_folksonomy_topics', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
